exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:960px){#app[data-v-7f786e63]{padding-bottom:0}.hide-nav #nav[data-v-7f786e63]{display:none}}", ""]);

// exports
